import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { useAuth } from "../../lib/auth";

export default function Profile() {
  const { user } = useAuth();
  return (
    <DashboardLayout>
      <div className="eyebrow mb-2">Profile</div>
      <h1 className="font-display text-4xl font-bold tracking-tight">Account</h1>

      <div className="mt-8 card-soft p-7 max-w-xl">
        <div className="flex items-center gap-4">
          {user?.picture ? (
            <img src={user.picture} alt="" className="h-14 w-14 rounded-full object-cover" />
          ) : (
            <div className="h-14 w-14 rounded-full bg-ink text-white grid place-items-center text-lg font-semibold">
              {(user?.name || "U").slice(0, 1).toUpperCase()}
            </div>
          )}
          <div>
            <div className="font-display text-xl font-semibold">{user?.name}</div>
            <div className="text-sm text-inkSoft">{user?.email}</div>
          </div>
        </div>
        <div className="mt-6 grid grid-cols-2 gap-3 text-sm">
          <div className="rounded-xl border border-line p-3">
            <div className="text-[11px] uppercase tracking-widest text-inkSoft">Auth</div>
            <div className="font-mono mt-1">{user?.auth_provider}</div>
          </div>
          <div className="rounded-xl border border-line p-3">
            <div className="text-[11px] uppercase tracking-widest text-inkSoft">User ID</div>
            <div className="font-mono mt-1 text-xs">{user?.user_id}</div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
